<table class="table table-bordered table-hover">
  <thead>
      <th scope="col" class="table-start">Proyecto</th>
      <th>Horario</th>
      <!-- <th>Tipo</th> -->
      <th scope="col" class="table-end">Acción</th>
  </thead>
  <tbody>
    <tr *ngFor="let slot of blockedSlots">
      <td>{{ slot.projectName || slot.project_name || 'Sin nombre' }}</td>
      <td>{{ formatHorario(slot) }}</td>
      <!-- <td>{{ slot.is_full_day ? 'Día completo' : 'Horario' }}</td> -->
      <td>
        <button class="btn btn-primary remove-btn" (click)="unblock(slot)">Desbloquear</button>
      </td>
    </tr>
  </tbody>
</table>

<app-loading-modal [visible]="showStatusModal" [status]="statusModalType" [message]="statusModalMessage"
  (closed)="onModalClosed()">
</app-loading-modal>
